import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer>
      <div className="footer_wrapper">
        <div className="footer_logo">
          <Link to={'/'}>
            <img src="/images/f_logo.png" alt="" />
          </Link>
          <p>ქართული ხარისხი!</p>
          <p>მტკიცე საფუძველი სამშენებლო ინდუსტრიისთვის</p>
        </div>
        <div className="footer_menu">
          <div className="f_menu_list">
            <Link className='f_link' to={'/catalog'}>სრული კატალოგი</Link>
            <Link to={'/about'}>ჩვენს შესახებ</Link>
            <Link to={'/about'}>კონტაქტი</Link>
          </div>
          <div className="f_social_list">
            <Link className='f_link' to={'/catalog'}>სოც. ქსელები</Link>
            <Link to={'https://www.facebook.com/@SkyHookGeorgia'} target='_blank'>Facebook</Link>
            <Link to={'https://www.instagram.com/skyhookgeorgia'} target='_blank'>Instagram</Link>
          </div>
        </div>
      </div>
      <div className="footer_copyrights">
        <p>© 2025 SKYHOOK.GE ყველა უფლება დაცულია</p>
        <p>Created by <a href="https://www.facebook.com/burtulacreative" target='_blank'>Burtula</a></p>
      </div>
    </footer>
  )
}

export default Footer